
const mutations={
  updateSmsNum(state,value){state.note.sms_num=value},//短信剩余条数
  updateSMScontent(state,value){state.note.SMScontent=value},// 更新群发短信内容
  updateMemberScreening(state,value){state.note.memberScreening=value},// 更新会员筛选条件
  updateCursNodeId2(state,value){state.userStatus.curs_node_id_2=value},//缓存门店id
}
export default mutations
